// MUST stay in sync with the backend's `card-gradients.catalog.ts` — the
// iframe is generated from its copy; if the two drift the preview lies.
export interface CardGradient {
  id: string;
  name: string;
  /** Raw CSS gradient string, ready to drop into a `background` property. */
  css: string;
}

export interface CardGradientGroup {
  id: string;
  name: string;
  items: CardGradient[];
}

export const CARD_GRADIENT_GROUPS: CardGradientGroup[] = [
  {
    id: "green",
    name: "Verdes",
    items: [
      {
        id: "coloca",
        name: "Coloca",
        css: "linear-gradient(135deg, oklch(0.508 0.118 165.612) 0%, oklch(0.378 0.077 168.94) 60%, oklch(0.262 0.051 172.552) 100%)",
      },
      { id: "bosque", name: "Bosque", css: "linear-gradient(135deg, #0b6c3a 0%, #08402a 60%, #042519 100%)" },
      {
        id: "esmeralda",
        name: "Esmeralda",
        css: "linear-gradient(135deg, #38c47e 0%, #0d8848 55%, #0a5530 100%)",
      },
      { id: "menta", name: "Menta", css: "linear-gradient(135deg, #a7f3d0 0%, #34d399 55%, #047857 100%)" },
      { id: "oliva", name: "Oliva", css: "linear-gradient(135deg, #a3a83c 0%, #4d5d22 55%, #1a1f0a 100%)" },
      { id: "jade", name: "Jade", css: "linear-gradient(135deg, #2dd4bf 0%, #0f766e 55%, #042f2e 100%)" },
    ],
  },
  {
    id: "blue",
    name: "Azules",
    items: [
      { id: "oceano", name: "Océano", css: "linear-gradient(135deg, #2563eb 0%, #1e3a8a 60%, #0c1e4d 100%)" },
      { id: "cielo", name: "Cielo", css: "linear-gradient(135deg, #38bdf8 0%, #0284c7 55%, #0c4a6e 100%)" },
      {
        id: "medianoche",
        name: "Medianoche",
        css: "linear-gradient(135deg, #312e81 0%, #1e1b4b 55%, #030712 100%)",
      },
      {
        id: "cobalto",
        name: "Cobalto",
        css: "linear-gradient(135deg, #4f46e5 0%, #312e81 55%, #1e1b4b 100%)",
      },
      {
        id: "turquesa",
        name: "Turquesa",
        css: "linear-gradient(135deg, #22d3ee 0%, #0e7490 55%, #083344 100%)",
      },
    ],
  },
  {
    id: "warm",
    name: "Cálidos",
    items: [
      {
        id: "atardecer",
        name: "Atardecer",
        css: "linear-gradient(135deg, #fb923c 0%, #dc2626 55%, #7c2d12 100%)",
      },
      { id: "rubi", name: "Rubí", css: "linear-gradient(135deg, #f43f5e 0%, #be123c 55%, #4c0519 100%)" },
      { id: "magma", name: "Magma", css: "linear-gradient(135deg, #facc15 0%, #ea580c 50%, #7f1d1d 100%)" },
      {
        id: "durazno",
        name: "Durazno",
        css: "linear-gradient(135deg, #fda4af 0%, #fb7185 50%, #be123c 100%)",
      },
      { id: "oro", name: "Oro", css: "linear-gradient(135deg, #fde047 0%, #ca8a04 55%, #422006 100%)" },
    ],
  },
  {
    id: "cool",
    name: "Fríos",
    items: [
      {
        id: "violeta",
        name: "Violeta",
        css: "linear-gradient(135deg, #a855f7 0%, #6d28d9 60%, #2e1065 100%)",
      },
      {
        id: "orquidea",
        name: "Orquídea",
        css: "linear-gradient(135deg, #f472b6 0%, #c026d3 55%, #4a044e 100%)",
      },
      {
        id: "lavanda",
        name: "Lavanda",
        css: "linear-gradient(135deg, #c4b5fd 0%, #8b5cf6 55%, #4c1d95 100%)",
      },
      { id: "fucsia", name: "Fucsia", css: "linear-gradient(135deg, #ec4899 0%, #a21caf 55%, #500724 100%)" },
    ],
  },
  {
    id: "neutral",
    name: "Neutros",
    items: [
      { id: "carbon", name: "Carbón", css: "linear-gradient(135deg, #4a5851 0%, #1f2924 60%, #0a0e0c 100%)" },
      {
        id: "platino",
        name: "Platino",
        css: "linear-gradient(135deg, #e5e7eb 0%, #9ca3af 50%, #374151 100%)",
      },
      {
        id: "pizarra",
        name: "Pizarra",
        css: "linear-gradient(135deg, #64748b 0%, #1e293b 55%, #020617 100%)",
      },
      { id: "arena", name: "Arena", css: "linear-gradient(135deg, #d6c4a8 0%, #8b7355 55%, #3d2f1f 100%)" },
      { id: "cafe", name: "Café", css: "linear-gradient(135deg, #b45309 0%, #78350f 55%, #1c1917 100%)" },
      {
        id: "porcelana",
        name: "Porcelana",
        css: "linear-gradient(135deg, #fafaf9 0%, #d6d3d1 55%, #57534e 100%)",
      },
    ],
  },
  {
    id: "multi",
    name: "Multicolor",
    items: [
      { id: "aurora", name: "Aurora", css: "linear-gradient(135deg, #38c47e 0%, #0284c7 50%, #7c3aed 100%)" },
      {
        id: "flamingo",
        name: "Flamingo",
        css: "linear-gradient(135deg, #fb7185 0%, #f472b6 50%, #a855f7 100%)",
      },
      { id: "iris", name: "Iris", css: "linear-gradient(135deg, #6366f1 0%, #ec4899 50%, #f97316 100%)" },
      {
        id: "tropico",
        name: "Trópico",
        css: "linear-gradient(135deg, #34d399 0%, #06b6d4 50%, #6366f1 100%)",
      },
    ],
  },
];

export const CARD_GRADIENTS: CardGradient[] = CARD_GRADIENT_GROUPS.flatMap((g) => g.items);

export const DEFAULT_GRADIENT_ID = "coloca";

export function findGradient(id?: string | null): CardGradient {
  if (!id) {
    return CARD_GRADIENTS.find((g) => g.id === DEFAULT_GRADIENT_ID)!;
  }
  return CARD_GRADIENTS.find((g) => g.id === id) ?? CARD_GRADIENTS.find((g) => g.id === DEFAULT_GRADIENT_ID)!;
}
